import { useState } from 'react'

import { Typography } from '@twistopayments/design-system/components/atoms/typography'
import { ChevronRightIcon } from '@twistopayments/design-system/icons/inline'

import type { SectionsTypeformComponent } from '@twisto/api-cms'

import { useHighlightedText } from 'homepage/libs/hooks'

import { Icon } from '../../atoms'

import * as styles from './typeform.styles'

const GRID_THRESHOLD = 6

export const Typeform = ({
  title,
  highlighted,
  subtitle,
  items,
  variant = 'single',
}: SectionsTypeformComponent) => {
  const { before, highlight, after } = useHighlightedText(title, highlighted)
  const [currentForm, setCurrentForm] = useState('')

  if (!items || items.length === 0) {
    return null
  }

  return (
    <section css={styles.section}>
      <div css={styles.content}>
        <Typography css={styles.subtitle} variant="h3">
          {subtitle}
        </Typography>
        <Typography css={styles.title} fontWeight="heavy" variant="h2">
          {before}
          <span css={styles.highlighted}>{highlight}</span>
          {after}
        </Typography>
      </div>
      {variant === 'single' ? (
        <iframe
          css={styles.form}
          loading="lazy"
          src={items[0]?.url}
          title={title}
        />
      ) : (
        <>
          {currentForm ? (
            <iframe
              css={styles.form}
              loading="lazy"
              src={currentForm}
              title={title}
            />
          ) : (
            <div
              css={[styles.list, items.length > GRID_THRESHOLD && styles.grid]}
            >
              {items.map((item) => (
                <button
                  key={item.id}
                  css={styles.formButton}
                  onClick={() => setCurrentForm(item.url || '')}
                >
                  <div css={styles.buttonContent}>
                    <Icon name={item.iconName} size="24" />
                    {item.text}
                  </div>
                  <ChevronRightIcon size="24" />
                </button>
              ))}
            </div>
          )}
        </>
      )}
    </section>
  )
}
